var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xxgk"},[_c('div',{staticClass:"breadcrumb"},[_c('a',{attrs:{"href":"/"}},[_vm._v("首页")]),_vm._v("  >  "+_vm._s(this.columnName))]),_vm._v(" "),_c('ul',_vm._l((_vm.xxgkList),function(item){return _c('li',{key:item.column_id,on:{"click":function($event){return _vm.details(item.column_id)}}},[_vm._v(_vm._s(item.column_name))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b012276","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/xxgk/xxgk.vue
// module id = null
// module chunks = 